/** Pre-purchase price display. Rounds UP so the estimate is never less than
 *  the actual charge. Emails use their own cents-precision formatter. */
export function formatPrice(cents: number): string {
  return `$${Math.ceil(cents / 100)}`;
}
